import React from 'react';
import { useTranslation } from 'react-i18next';
import { RoiServiceMetric } from '../types';
import RankedBarList from './RankedBarList';

interface Props {
  services: RoiServiceMetric[];
}

const HitRateByService: React.FC<Props> = ({ services }) => {
  const { t } = useTranslation('admin');

  const items = services.map(s => ({
    label: s.serviceName,
    value: s.hitRate,
    displayValue: `${Math.round(s.hitRate * 100)}%`,
  }));

  return (
    <div className="roi-panel">
      <h3 className="roi-panel-title">{t('roiInsights.panels.hitRate')}</h3>
      {items.length === 0 ? (
        <div className="roi-panel-empty">{t('roiInsights.noData')}</div>
      ) : (
        <RankedBarList items={items} barColor="#a78bfa" />
      )}
    </div>
  );
};

export default HitRateByService;
